import { gql } from "@apollo/client";

export const GET_STOCKPILES_INPUT = gql`
  query GetStockpilesInput($requestId: String!) @api(name: "cosmos") {
    getInputData(requestId: $requestId) {
      input {
        Zn_Percent {
          stockpile
          distance
          value
        }
        Pb_Percent {
          stockpile
          distance
          value
        }
        Fe_Percent {
          stockpile
          distance
          value
        }
        Ba_Percent {
          stockpile
          distance
          value
        }
        TOC_Percent {
          stockpile
          distance
          value
        }
        ZnPb_Ratio {
          stockpile
          distance
          value
        }
        ZnFe_Ratio {
          stockpile
          distance
          value
        }
        PbFe_Ratio {
          stockpile
          distance
          value
        }
        Grain_Size_T2 {
          stockpile
          distance
          value
        }
        SiO2_Percent {
          stockpile
          distance
          value
        }
        sPb_Percent {
          stockpile
          distance
          value
        }
        eS_Percent {
          stockpile
          distance
          value
        }
        Cu_Percent {
          stockpile
          distance
          value
        }
        RPb_Ratio {
          stockpile
          distance
          value
        }
        Grain_Size_T1 {
          stockpile
          distance
          value
        }
        Grain_Size_T6 {
          stockpile
          distance
          value
        }
        Chemistry_T3 {
          stockpile
          distance
          value
        }
        Chemistry_T4 {
          stockpile
          distance
          value
        }
        Chemistry_T5 {
          stockpile
          distance
          value
        }
        Chemistry_T7 {
          stockpile
          distance
          value
        }
        Chemistry_T8 {
          stockpile
          distance
          value
        }
        Chemistry_T9 {
          stockpile
          distance
          value
        }
        Zn_T2 {
          stockpile
          distance
          value
        }
        Zn_T1 {
          stockpile
          distance
          value
        }
        Zn_T6 {
          stockpile
          distance
          value
        }
        Pb_T2 {
          stockpile
          distance
          value
        }
        Pb_T1 {
          stockpile
          distance
          value
        }
        Pb_T6 {
          stockpile
          distance
          value
        }
        Grain_Size_T1_Grain_Size_T6 {
          stockpile
          distance
          value
        }
      }
    }
  }
`;

export const GET_STOCKPILES_DATES = gql`
  query GetStockpilesDates($requestId: String!) @api(name: "cosmos") {
    getStockpileDates(requestId: $requestId) {
      dates
    }
  }
`;

export const GET_STOCKPILES_OUTPUT = gql`
  query GetStockpilesOutput($requestId: String!) @api(name: "cosmos") {
    getOutputData(requestId: $requestId) {
      output {
        Zn_Circuit_Recovery {
          value
          distance
          stockpile
        }
        Zn_Final_Concentrate_Percent {
          value
          distance
          stockpile
        }
        Pb_Final_Concentrate_Percent {
          value
          distance
          stockpile
        }
        Pb_Circuit_Recovery {
          value
          distance
          stockpile
        }
        Mill_TPH {
          value
          distance
          stockpile
        }
        Passing_325_Percent {
          value
          distance
          stockpile
        }
        F80 {
          value
          distance
          stockpile
        }
        P80 {
          value
          distance
          stockpile
        }
        Bond_Work_Index {
          value
          distance
          stockpile
        }
        SAG_kWh {
          value
          distance
          stockpile
        }
        BM_kWh {
          value
          distance
          stockpile
        }
        kWh_Tonne {
          value
          distance
          stockpile
        }
        Start_Date {
          value
          distance
          stockpile
        }
        End_Date {
          value
          distance
          stockpile
        }
        MF_Dry_Tonnes {
          value
          distance
          stockpile
        }
        MF_Dry_Tonnes_TPH {
          value
          distance
          stockpile
        }
        ZnFilter_Dry_Tonnes {
          value
          distance
          stockpile
        }
        ZnFilter_Dry_Tonnes_TPH {
          value
          distance
          stockpile
        }
        Distance {
          value
          distance
          stockpile
        }
        Pi_TPOH {
          value
          distance
          stockpile
        }
      }
    }
  }
`;

export const GET_EQUIPMENT_AVAILABILITY = gql`
  query GetEquipmentAvailability(
    $stockpilesData: [EquipmentAvailabilityInputType!]!
  ) @api(name: "adx") {
    getEquipmentAvailability(stockpilesData: $stockpilesData) {
      SAG_Utilization {
        value
        stockpile
        distance
      }
      SAG1_Utilization {
        value
        stockpile
        distance
      }
      SAG2_Utilization {
        value
        stockpile
        distance
      }
      SAG3_Utilization {
        value
        stockpile
        distance
      }
      BM1_Available {
        value
        stockpile
        distance
      }
      BM2_Available {
        value
        stockpile
        distance
      }
      BM3_Available {
        value
        stockpile
        distance
      }
      BM4_Available {
        value
        stockpile
        distance
      }
      Quaternary_Isamill_Available {
        value
        stockpile
        distance
      }
      Pb_Tower_Mill1_Available {
        value
        stockpile
        distance
      }
      Pb_Tower_Mill4_Available {
        value
        stockpile
        distance
      }
      Pb_Tower_Mill5_Available {
        value
        stockpile
        distance
      }
      Zn_Rougher_Isamill_Available {
        value
        stockpile
        distance
      }
    }
  }
`;

export const GET_LOW_TONNAGE_EVENTS = gql`
  query GetLowTonnage($stockpiles: [String!]!) @api(name: "adx") {
    getLowTonnageEvents(stockpiles: $stockpiles) {
      lte
    }
  }
`;

export const GET_SENSORS_LIST = gql`
  query @api(name: "adx") {
    listOfDataSetpoints {
      label
      value
    }
  }
`;

export const GET_LIST_OF_INCLUDED_STOCKPILES = gql`
  query @api(name: "cosmos") {
    getListOfIncludedStockpiles {
      id
      stockpile
    }
  }
`;

export const GET_LIST_OF_FORECASTS_MONTHS = gql`
  query @api(name: "cosmos") {
    getListOfAvailableMonthsWithTargets {
      availableTargetMonths
    }
  }
`;

export const GET_INCLUDED_STOCKPILE_DETAILS = gql`
  query GetIncludedStockpileDetails($id: String!, $stockpile: String!)
  @api(name: "cosmos") {
    getIncludedStockpileDetails(id: $id, stockpile: $stockpile) {
      id
      Zn_Gr
      Zn_Rec
      Pb_Gr
      Pb_Rec
      TPOH
      SP
      inputStockpile
      updatedBy
      updatedAt
    }
  }
`;

export const GET_ACTIVE_FORECAST = gql`
  query GetActiveForecast($monthId: String!) @api(name: "cosmos") {
    getActiveForecast(monthId: $monthId) {
      forecastId
      id
      notes
      createdAt
      createdBy
      updatedAt
      updatedBy
      monthId
      includedStockpiles {
        id
        Zn_Rec
        Zn_Gr
        Pb_Rec
        Pb_Gr
        TPOH
        SP
        Zn_Fd
        Pb_Fd
        updatedBy
        updatedAt
        inputStockpile
        numberOfDays
      }
    }
  }
`;

export const GET_MATCHING_REQUESTS = gql`
  query GetMatchingRequests($limit: Float, $offset: Float, $search: String)
  @api(name: "cosmos") {
    getMatchingRequests(limit: $limit, offset: $offset, search: $search) {
      requestsList {
        createdBy
        createdAt
        requestId
        name
        successStatus
        bestMatch
      }
      total
    }
  }
`;

export const GET_USER_INPUT_DATA = gql`
  query GetUserInputData($requestId: String!) @api(name: "cosmos") {
    getUserInputData(requestId: $requestId) {
      startDate
      endDate
      stockpileName
      tableInputs
      tableWeights
    }
  }
`;

export function prepareQueryForGraphs(stockpiles: string[], tag: string) {
  let piData: string = "";

  for (let i = 0; i < stockpiles.length; i++) {
    piData += `${stockpiles[i].replace(
      / /,
      ""
    )}: piDataView(inputData: { stockpileId: "${
      stockpiles[i]
    }", tag: "${tag}" }) {
      name
      id: name
      data
      timeline
      plotBands {
        from
        to
      }
      lte
    }
    `;
  }

  return gql`
    query @api(name: "adx") {
      ${piData}
    }
  `;
}

export const EXPORT_GRAPH = gql`
  query ExportHighChart($inputGraphOptionData: GraphOptions!)
  @api(name: "adx") {
    exportHighChart(inputGraphOptionData: $inputGraphOptionData) {
      base64Image
      sensorId
    }
  }
`;

export const GET_LATEST_STOCKPILES = gql`
  query getLatestStockpiles @api(name: "adx") {
    getLatestStockpiles {
      Stockpile
      max_Pi_Date
    }
  }
`;

export const GET_PREPROCESSOR_START = gql`
  query getPreprocessorStart @api(name: "adx") {
    getPreprocessorStart {
      PreProcessStart
      PreProcessEnd
    }
  }
`;

export const GET_RELINE = gql`
  query getReline @api(name: "adx") {
    getReline {
      sag1_reline_start_date
      sag1_reline_end_date
      sag2_reline_start_date
      sag2_reline_end_date
      sag3_reline_start_date
      sag3_reline_end_date
    }
  }
`;
